var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99913 0.5C8.30772 0.5 7.74913 1.05859 7.74913 1.75V2.5C4.89757 3.07812 2.74913 5.60156 2.74913 8.625V9.35938C2.74913 11.1953 2.07335 12.9688 0.854599 14.3438L0.565536 14.668C0.237411 15.0352 0.159286 15.5625 0.358505 16.0117C0.557724 16.4609 1.00694 16.75 1.49913 16.75H16.4991C16.9913 16.75 17.4366 16.4609 17.6398 16.0117C17.8429 15.5625 17.7608 15.0352 17.4327 14.668L17.1437 14.3438C15.9249 12.9688 15.2491 11.1992 15.2491 9.35938V8.625C15.2491 5.60156 13.1007 3.07812 10.2491 2.5V1.75C10.2491 1.05859 9.69054 0.5 8.99913 0.5ZM10.7687 19.7695C11.2374 19.3008 11.4991 18.6641 11.4991 18H8.99913H6.49913C6.49913 18.6641 6.76085 19.3008 7.2296 19.7695C7.69835 20.2383 8.33507 20.5 8.99913 20.5C9.66319 20.5 10.2999 20.2383 10.7687 19.7695Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.155d0f3739bf1e6629944251a12d5169.svg";
export { ForwardRef as ReactComponent };